/*eslint no-multi-spaces: "off"*/
import React, { useState,
  useRef,
  useContext }                from 'react';
import { useTranslation}      from 'react-i18next';
import { toast }              from 'react-toastify';
import MonetizationOn         from '@material-ui/icons/MonetizationOn';
import {  showAddon,
  editAddon,
createAddon }                 from '~/config/routes';
import List                   from '~/containers/List';
import currencyCodeToCurrency from '~/utils/currencyCodeToCurrency';
import toCurrency             from '~/utils/Number/toCurrency';
import Request                from '~/providers/Request';
import ModalDelete            from '~/components/ModalDelete';
import AddonContext           from '../context';
import packageTypesEnum       from '~/enums/packageTypesEnum';
import packagePeriodEnum      from '~/enums/packagePeriodEnum';
import moment                 from 'moment';
import { AbilityContext }     from '~/contexts/Can';

function AddonList() {
  const { t } = useTranslation();
  const [ modalInfo, setModalInfo ] = useState({ show: false });
  const listEl = useRef(null);
  const { delRecord } = useContext(AddonContext);
  const ability = useContext(AbilityContext);
  const trAttr = (attr) => t(`addon.attributes.${attr}`);

  function handleDeletionModal(id, name){
    setModalInfo({ show: true, id, name });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/packages/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Addons')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Addons')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Addons')) {
    actions.push('del');
  }
  if(ability.can('show', 'Addons')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createAddon}
        routeToEdit={editAddon}
        routeToShow={showAddon}
        listEl={listEl}
        path={'/admin/packages/'}
        actions={actions}
        paperProps={{
          Icon:MonetizationOn,
          iconColor:'green',
          title:t('addon.defPlural'),
        }}
        columns={[
          { field: 'is_active', type: 'boolean',  title: trAttr('is_active') },
          { field: 'name',      type: 'string',   title: trAttr('name') },
          { field: 'price',     type: 'currency', title: trAttr('price'),
            render: function Coin(rowData){
              return <label>{`${currencyCodeToCurrency(rowData.coin)} ${toCurrency(rowData.price)}`}</label>;
            }
          },
          { field: 'type',           type: 'string',   title: trAttr('type'),
            lookup: packageTypesEnum().objects()
          },
          { field: 'period',           type: 'string',   title: trAttr('period'),
            lookup: packagePeriodEnum().objects()
          },
          { field: 'resources_size', type: 'numeric',  title: trAttr('resources_size'), precision: 0 },
          { field: 'updated_at',     type: 'datetime', title: trAttr('updated_at') },
        ]}
        context={AddonContext}
        recordMap={
          record => ({
            ...record,
            created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />
      <ModalDelete
        modal={modalInfo.show}
        onClose={() => setModalInfo({ show: false })}
        name={modalInfo.name}
        id={modalInfo.id}
        deleteAction={handleDelete}
      />
    </div>
  );
}

export default React.memo(AddonList);
